import React from "react";
import ReactDOM from "react-dom/client";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthProvider from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./components/muiTheme";
import compose from "./helpers/compose";
import AppProvider from "./AppProvider";

const Provider = compose([AuthProvider, BrowserRouter]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider theme={theme}>
      <Provider>
        <AppProvider> {/* App Providers were extracted from the App component to prevent unnessessary re-renders */}
         <App />
        </AppProvider>
      </Provider>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
